// must be js because it's needed by next.config.js

// Our url scheme handling (around rewrites/redirects below)
// is not able to handle story slugs with directories ("/" in the name).
// So these are ignored in the URL
// and we have this workaround in storyblock-backend.ts:handleStoriesInDirectories:
// -> Everything starting with "abc_" gets prepended the directory "abc/". so We get "abc/abc_"
module.exports = {
  // prettier-ignore
  storiesRedirectedToInfo: [
    "service",
    "impressum", "mentions-legales", "colofon",
    "bildnachweise", "pagerightsbildnachweise",
    "home",
    "agb", "cgv", "algemene-voorwaarden","newsletter-unsubscribe-error","afmelding","desabonner-de-la-newsletter","newsletter-abmeldung"
  ],
  // prettier-ignore
  specialDirectories: [
    "acceptance",
    "playground",
    "global",
    "landing",
    "lp",
  ],
  ignoredDirectories: ["settings"],

  // see also constants.cjs
  defaultUbLocaleByDomain: {
    "udobaer.at": "at-de",
    "udobaer.ch": "ch-de",
    "udobaer.de": "de-de",
    "udobaer.fr": "fr-fr",
    "udobaer.nl": "nl-nl",
    "udobaer.be": "be-nl",
    "udobaer.it": "it-it",
    "udobaer.eu": "en-en",
    "": "de-de", // Default (when the others don't match)
  },
  ubLocalesByDomain: {
    // this is partly redundant with defaultUbLocaleByDomain:
    "udobaer.at": ["at-de"],
    "udobaer.ch": ["ch-de", "ch-fr"],
    "udobaer.de": ["de-de"],
    "udobaer.fr": ["fr-fr"],
    "udobaer.nl": ["nl-nl"],
    "udobaer.be": ["be-nl", "be-fr"],
    "udobaer.it": ["it-it"],
    "udobaer.eu": ["en-en"],
    "": ["de-de"], // Default (when the others don't match)
  },
  brandsIndexedByUbLocale: {
    "at-de": "markenindex",
    "ch-de": "markenindex",
    "de-de": "markenindex",
    "fr-fr": "marques-index",
    "nl-nl": "merk-index",
    "be-nl": "merk-index",
    "it-it": "indice-del-marchio",
    "ch-fr": "marques-index",
    "en-en": "brand-index",
    "": "marken", // Default (when the others don't match)
  },
  brandsByUbLocale: {
    "at-de": "marken",
    "ch-de": "marken",
    "de-de": "marken",
    "fr-fr": "marques",
    "nl-nl": "merken",
    "be-nl": "merken",
    "it-it": "marchio",
    "ch-fr": "marques",
    "en-en": "brands",
    "": "marken", // Default (when the others don't match)
  },
}
